import { Controller } from "@hotwired/stimulus"

// data-controller="crud--upload-arquivo"
// Substitui o <script> inline de _upload_arquivo.html.erb
export default class extends Controller {
  static targets = ["input", "btn", "rm", "name", "meta", "icon"]

  connect() {
    this.setEmpty()
  }

  choose() {
    this.inputTarget.click()
  }

  remove() {
    this.inputTarget.value = ""
    this.setEmpty()
  }

  changed() {
    const input = this.inputTarget
    if (!input.files || !input.files[0]) {
      this.setEmpty()
      return
    }
    this.setFile(input.files[0])
  }

  // --- private ---

  setEmpty() {
    this.nameTarget.textContent = "Nenhum arquivo selecionado"
    this.rmTarget.style.display = "none"
    this.iconTarget.className = "fas fa-file-alt text-gray-400"
  }

  setFile(file) {
    this.nameTarget.textContent = file.name || "Arquivo selecionado"
    this.rmTarget.style.display = ""

    const name = (file.name || "").toLowerCase()
    const isPdf = file.type === "application/pdf" || name.endsWith(".pdf")

    if (isPdf) {
      this.iconTarget.className = "fas fa-file-pdf text-red-500"
    } else if (file.type && file.type.startsWith("image/")) {
      this.iconTarget.className = "fas fa-file-image text-green-600"
    } else {
      this.iconTarget.className = "fas fa-file-alt text-gray-500"
    }
  }
}
